module.exports = __webpack_public_path__ + "static/gallery-9-a36d7d143926565a43dedb93dd01ddae.jpg";